import { Injectable }                                   from "@angular/core";
import { CONFIGURATION }                                from "../../../../app.constants";
import { Application }               from "../../../../models";
import { Observable }                                   from "rxjs/Observable";
import { HttpDataService }                              from "../../../../services/shared";
@Injectable()
export class AppAcessService {

    constructor(private httpData: HttpDataService) {
    }
    public Add(application: Application): Observable<Application> {
        return Observable.create((observer) => {
            this.httpData.post(CONFIGURATION.baseUrls.apiUrl + "application", JSON.stringify(application))
                .map(response => <Application>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public Update(application: Application): Observable<Application> {
        return Observable.create((observer) => {
            this.httpData.put(CONFIGURATION.baseUrls.apiUrl + "application", JSON.stringify(application))
                .map(response => <Application>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/userHome/applicationAccess/appAccess/appAccess.service.ts